import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';  // ✅ added HTTP_INTERCEPTORS
import { RouterModule, Routes } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AppComponent } from './app.component';
import { AgmCoreModule } from '@agm/core';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AjouterAgencieComponent } from './ajouter-agencie/ajouter-agencie.component';
import { ModifierAgencieComponent } from './modifier-agencie/modifier-agencie.component';
import { AjouterAdminsComponent } from './ajouter-admins/ajouter-admins.component';
import { ModifierAdminsComponent } from './modifier-admins/modifier-admins.component';
import { AjouterMobileAppsComponent } from './ajouter-mobile-apps/ajouter-mobile-apps.component';
import { ModifierMobileAppsComponent } from './modifier-mobile-apps/modifier-mobile-apps.component';
import { ProfileComponent } from './profile/profile.component';
import { AjouterAdsComponent } from './ajouter-ads/ajouter-ads.component';
import { ModifierAdsComponent } from './modifier-ads/modifier-ads.component';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoginComponent } from './login/login.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { JwtModule } from '@auth0/angular-jwt';
import { InterceptorInterceptor } from './services/admins/interceptor.interceptor';
import { AdminAuthInterceptor } from './interceptors/admin-auth.interceptor';  // ✅ your new interceptor
import { ToastyModule } from 'ng2-toasty';
import { AjouterProduitComponent } from './ajouter-produit/ajouter-produit.component';
import { ModifierProduitComponent } from './modifier-produit/modifier-produit.component';
import { AjouterProjetComponent } from './ajouter-projet/ajouter-projet.component';
import { ModifierProjetComponent } from './modifier-projet/modifier-projet.component';
import { AjouterCategorieComponent } from './ajouter-categorie/ajouter-categorie.component';
import { AjouterPiecesComponent } from './ajouter-pieces/ajouter-pieces.component';
import { ChipsModule } from 'primeng/chips';
import { AccordionModule } from 'primeng/accordion';
import { ListeSousCategorieComponent } from './liste-sous-categorie/liste-sous-categorie.component';
import { AjouterSousCategorieComponent } from './ajouter-sous-categorie/ajouter-sous-categorie.component';
import { ModifierSousCategorieComponent } from './modifier-sous-categorie/modifier-sous-categorie.component';
import { ListePiecesComponent } from './liste-pieces/liste-pieces.component';
import { ModifierPieceComponent } from './modifier-piece/modifier-piece.component';
import { ListboxModule } from 'primeng/listbox';
import { ListePlansComponent } from './liste-plans/liste-plans.component';
import { ListeServicesComponent } from './liste-services/liste-services.component';
import { AjouterServicesComponent } from './ajouter-services/ajouter-services.component';
import { ModifierServiceComponent } from './modifier-service/modifier-service.component';
import { AjouterSousServiceComponent } from './ajouter-sous-service/ajouter-sous-service.component';
import { ListeSousServiceComponent } from './liste-sous-service/liste-sous-service.component';
import { ModifierSousServiceComponent } from './modifier-sous-service/modifier-sous-service.component';
import { ListeBiensImmobComponent } from './liste-biens-immob/liste-biens-immob.component';
import { AjouterBiensImmobComponent } from './ajouter-biens-immob/ajouter-biens-immob.component';
import { ModifierBiensImmobComponent } from './modifier-biens-immob/modifier-biens-immob.component';
import { AjouterSousBiensComponent } from './ajouter-sous-biens/ajouter-sous-biens.component';
import { ListeSousBiensComponent } from './liste-sous-biens/liste-sous-biens.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ModifierSousImmobComponent } from './modifier-sous-immob/modifier-sous-immob.component';
import { DropdownModule } from 'primeng/dropdown';
import { ListeMeilleursBiensComponent } from './liste-meilleurs-biens/liste-meilleurs-biens.component';
import { AjouterMeilleursBiensComponent } from './ajouter-meilleurs-biens/ajouter-meilleurs-biens.component';
import { ListeBiensComponent } from './liste-biens/liste-biens.component';
import { ListeSousMeilleursBiensComponent } from './liste-sous-meilleurs-biens/liste-sous-meilleurs-biens.component';
import { AjouterSousMeilleursBiensComponent } from './ajouter-sous-meilleurs-biens/ajouter-sous-meilleurs-biens.component';
import { GestionclientComponent } from './gestionClient/gestionclient.component';
import { AjouterClientComponent } from './ajouter-client/ajouter-client.component';
import { ModifierClientComponent } from './modifier-client/modifier-client.component';
import { ListeDemandesComponent } from './liste-demandes/liste-demandes.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ConceptionClientComponent } from './conception-client/conception-client.component';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { ListeMagazineComponent } from './liste-magazine/liste-magazine.component';
import { AjouterMagazineComponent } from './ajouter-magazine/ajouter-magazine.component';
import { ModifierMagazineComponent } from './modifier-magazine/modifier-magazine.component';
import { PromoteursTunisComponent } from './promoteurs-immob/promoteurs-tunis/promoteurs-tunis.component';
import { PromoteursSousseComponent } from './promoteurs-immob/promoteurs-sousse/promoteurs-sousse.component';
import { PromoteursMonastirComponent } from './promoteurs-immob/promoteurs-monastir/promoteurs-monastir.component';
import { PromoteursMahdiaComponent } from './promoteurs-immob/promoteurs-mahdia/promoteurs-mahdia.component';
import { PromoteursSfaxComponent } from './promoteurs-immob/promoteurs-sfax/promoteurs-sfax.component';
import { PromoteursNabeulComponent } from './promoteurs-immob/promoteurs-nabeul/promoteurs-nabeul.component';
import { PromoteursBizerteComponent } from './promoteurs-immob/promoteurs-bizerte/promoteurs-bizerte.component';
import { PromoteursTbarkaComponent } from './promoteurs-immob/promoteurs-tbarka/promoteurs-tbarka.component';
import { PromoteursJerbaComponent } from './promoteurs-immob/promoteurs-jerba/promoteurs-jerba.component';
import { AgencesTunisComponent } from './agences-immob/agences-tunis/agences-tunis.component';
import { AgencesSousseComponent } from './agences-immob/agences-sousse/agences-sousse.component';
import { AgencesMonastirComponent } from './agences-immob/agences-monastir/agences-monastir.component';
import { AgencesMahdiaComponent } from './agences-immob/agences-mahdia/agences-mahdia.component';
import { AgencesSfaxComponent } from './agences-immob/agences-sfax/agences-sfax.component';
import { AgencesNabeulComponent } from './agences-immob/agences-nabeul/agences-nabeul.component';
import { AgencesBizerteComponent } from './agences-immob/agences-bizerte/agences-bizerte.component';
import { AgencesBanquesComponent } from './agences-services/agences-banques/agences-banques.component';
import { AgencesAssurancesComponent } from './agences-services/agences-assurances/agences-assurances.component';
import { AgencesBurauxEtudesComponent } from './agences-services/agences-buraux-etudes/agences-buraux-etudes.component';
import { AgencesDecorationComponent } from './agences-services/agences-decoration/agences-decoration.component';
import { AgencesProArtisanatComponent } from './agences-services/agences-pro-artisanat/agences-pro-artisanat.component';
import { AgencesDiversComponent } from './agences-services/agences-divers/agences-divers.component';
import { AgencesCommercesComponent } from './agences-services/agences-commerces/agences-commerces.component';
import { AgencesSocieteServicesComponent } from './agences-services/agences-societe-services/agences-societe-services.component';
import { MeilleursBienTunisComponent } from './meilleurs-biens/meilleurs-bien-tunis/meilleurs-bien-tunis.component';
import { MeilleursBienSousseComponent } from './meilleurs-biens/meilleurs-bien-sousse/meilleurs-bien-sousse.component';
import { MeilleursBienMonastirComponent } from './meilleurs-biens/meilleurs-bien-monastir/meilleurs-bien-monastir.component';
import { MeilleursBienMahdiaComponent } from './meilleurs-biens/meilleurs-bien-mahdia/meilleurs-bien-mahdia.component';
import { MeilleursBienSfaxComponent } from './meilleurs-biens/meilleurs-bien-sfax/meilleurs-bien-sfax.component';
import { MeilleursBienNabeulComponent } from './meilleurs-biens/meilleurs-bien-nabeul/meilleurs-bien-nabeul.component';
import { MeilleursBienBizerteComponent } from './meilleurs-biens/meilleurs-bien-bizerte/meilleurs-bien-bizerte.component';
import { EquipementComponent } from './materiaux/equipement/equipement.component';
import { AutomatismeComponent } from './materiaux/automatisme/automatisme.component';
import { ChauffageComponent } from './materiaux/chauffage/chauffage.component';
import { EnergieComponent } from './materiaux/energie/energie.component';
import { MeubleComponent } from './materiaux/meuble/meuble.component';
import { ProtectionComponent } from './materiaux/protection/protection.component';
import { MenuiserieComponent } from './materiaux/menuiserie/menuiserie.component';
import { PeintureDecorationComponent } from './materiaux/peinture-decoration/peinture-decoration.component';
import { Recherche1Pipe } from './pipes/recherche1.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { NouvelleDemandeComponent } from './nouvelle-demande/nouvelle-demande.component';
import { ProjectsListComponent } from './promoteurs-immob/projects-list/projects-list.component';
import { AppartementListComponent } from './promoteurs-immob/appartement-list/appartement-list.component';
import { ProduitsListComponent } from './materiaux/produits-list/produits-list.component';
import { SousProduitsListComponent } from './materiaux/sous-produits-list/sous-produits-list.component';
import { ListBienComponent } from './meilleurs-biens/list-bien/list-bien.component';
import { ListSousBienComponent } from './meilleurs-biens/list-sous-bien/list-sous-bien.component';
import { AgencesCoffeeComponent } from './agences-services/agences-coffee/agences-coffee.component';
import { CoffeeListComponent } from './coffee-list/coffee-list.component';
import { MenuListComponent } from './menu-list/menu-list.component';
import { CafeRestoTunisComponent } from './cafe-resto/cafe-resto-tunis/cafe-resto-tunis.component';
import { CafeRestoSousseComponent } from './cafe-resto/cafe-resto-sousse/cafe-resto-sousse.component';
import { AjouterCafeRestoComponent } from './ajouter-cafe-resto/ajouter-cafe-resto.component';
import { CafeRestoMonastirComponent } from './cafe-resto/cafe-resto-monastir/cafe-resto-monastir.component';
import { CafeRestoMahdiaComponent } from './cafe-resto/cafe-resto-mahdia/cafe-resto-mahdia.component';
import { CafeRestoSfaxComponent } from './cafe-resto/cafe-resto-sfax/cafe-resto-sfax.component';
import { CafeRestoNabeulComponent } from './cafe-resto/cafe-resto-nabeul/cafe-resto-nabeul.component';
import { CafeRestoBizerteComponent } from './cafe-resto/cafe-resto-bizerte/cafe-resto-bizerte.component';
import { ListAgenceBienComponent } from './agences-immob/list-agence-bien/list-agence-bien.component';
import { ListAgenceSousBienComponent } from './agences-immob/list-agence-sous-bien/list-agence-sous-bien.component';
import { AjouterBienimmobComponent } from './ajouter-bienimmob/ajouter-bienimmob.component';
import { ListOfServicesComponent } from './agences-services/list-of-services/list-of-services.component';
import { ListOfSousServicesComponent } from './agences-services/list-of-sous-services/list-of-sous-services.component';
import { AnnonceComponent } from './annonce/annonce/annonce.component';
import { AddAnnonceComponent } from './annonce/add-annonce/add-annonce.component';
import { EditAnnonceComponent } from './annonce/edit-annonce/edit-annonce.component';
import { AnnonceAttenteComponent } from './annonce/annonce-attente/annonce-attente.component';
import { AnnonceAttenteByIdComponent } from './annonce/annonce-attente-by-id/annonce-attente-by-id.component';
import { AgencesDjerbaComponent } from './agences-immob/agences-djerba/agences-djerba.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { PromoteurListComponent } from './promoteurs-immob/promoteur-list/promoteur-list.component';
import { ListeAgenceMobComponent } from './agences-immob/liste-agence-mob/liste-agence-mob.component';
import { ListemateriauxComponent } from './materiaux/listemateriaux/listemateriaux.component';
import { ListeagenceserviceComponent } from './agences-services/listeagenceservice/listeagenceservice.component';
import { ListnewannonceComponent } from './annonce-new/listnewannonce/listnewannonce.component';
import { AddnewannonceComponent } from './annonce-new/addnewannonce/addnewannonce.component';
import { UpdateannonceComponent } from './annonce-new/updateannonce/updateannonce.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: LoginComponent }
];

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule.forRoot(routes, {
      enableTracing: true,
      useHash: false,
      initialNavigation: 'enabledNonBlocking'
    }),
    AppRoutingModule,
    AgmCoreModule.forRoot({
      apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    }),
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatToolbarModule,
    MatCardModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTooltipModule,
    ChipsModule,
    AccordionModule,
    ListboxModule,
    MatPaginatorModule,
    DropdownModule,
    DialogModule,
    ButtonModule,
    ToastModule,
    MatAutocompleteModule,
    RippleModule,
    ToastyModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          if (typeof window !== 'undefined') {
            return localStorage.getItem('access_token');
          }
          return null;
        },
        allowedDomains: ['localhost:4200'],
        disallowedRoutes: ['localhost/login']
      }
    }),
  ],

  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AjouterAgencieComponent,
    ModifierAgencieComponent,
    AjouterAdminsComponent,
    ModifierAdminsComponent,
    AjouterMobileAppsComponent,
    ModifierMobileAppsComponent,
    ProfileComponent,
    AjouterAdsComponent,
    ModifierAdsComponent,
    LoginComponent,
    AjouterProduitComponent,
    ModifierProduitComponent,
    AjouterProjetComponent,
    ModifierProjetComponent,
    AjouterCategorieComponent,
    AjouterPiecesComponent,
    ListeSousCategorieComponent,
    AjouterSousCategorieComponent,
    ModifierSousCategorieComponent,
    ListePiecesComponent,
    ModifierPieceComponent,
    ListePlansComponent,
    ListeServicesComponent,
    AjouterServicesComponent,
    ModifierServiceComponent,
    AjouterSousServiceComponent,
    ListeSousServiceComponent,
    ModifierSousServiceComponent,
    ListeBiensImmobComponent,
    AjouterBiensImmobComponent,
    ModifierBiensImmobComponent,
    AjouterSousBiensComponent,
    ListeSousBiensComponent,
    ModifierSousImmobComponent,
    ListeMeilleursBiensComponent,
    AjouterMeilleursBiensComponent,
    ListeBiensComponent,
    ListeSousMeilleursBiensComponent,
    AjouterSousMeilleursBiensComponent,
    GestionclientComponent,
    AjouterClientComponent,
    ModifierClientComponent,
    ListeDemandesComponent,
    ConceptionClientComponent,
    ListeMagazineComponent,
    AjouterMagazineComponent,
    ModifierMagazineComponent,
    PromoteursTunisComponent,
    PromoteursSousseComponent,
    PromoteursMonastirComponent,
    PromoteursMahdiaComponent,
    PromoteursSfaxComponent,
    PromoteursNabeulComponent,
    PromoteursBizerteComponent,
    PromoteursTbarkaComponent,
    PromoteursJerbaComponent,
    AgencesTunisComponent,
    AgencesSousseComponent,
    AgencesMonastirComponent,
    AgencesMahdiaComponent,
    AgencesSfaxComponent,
    AgencesNabeulComponent,
    AgencesBizerteComponent,
    AgencesBanquesComponent,
    AgencesAssurancesComponent,
    AgencesBurauxEtudesComponent,
    AgencesDecorationComponent,
    AgencesProArtisanatComponent,
    AgencesDiversComponent,
    AgencesCommercesComponent,
    AgencesSocieteServicesComponent,
    MeilleursBienTunisComponent,
    MeilleursBienSousseComponent,
    MeilleursBienMonastirComponent,
    MeilleursBienMahdiaComponent,
    MeilleursBienSfaxComponent,
    MeilleursBienNabeulComponent,
    MeilleursBienBizerteComponent,
    EquipementComponent,
    AutomatismeComponent,
    ChauffageComponent,
    EnergieComponent,
    MeubleComponent,
    ProtectionComponent,
    MenuiserieComponent,
    PeintureDecorationComponent,
    Recherche1Pipe,
    NouvelleDemandeComponent,
    ProjectsListComponent,
    AppartementListComponent,
    ProduitsListComponent,
    SousProduitsListComponent,
    ListBienComponent,
    ListSousBienComponent,
    AgencesCoffeeComponent,
    CoffeeListComponent,
    MenuListComponent,
    CafeRestoTunisComponent,
    CafeRestoSousseComponent,
    AjouterCafeRestoComponent,
    CafeRestoMonastirComponent,
    CafeRestoMahdiaComponent,
    CafeRestoSfaxComponent,
    CafeRestoNabeulComponent,
    CafeRestoBizerteComponent,
    ListAgenceBienComponent,
    ListAgenceSousBienComponent,
    AjouterBienimmobComponent,
    ListOfServicesComponent,
    ListOfSousServicesComponent,
    AnnonceComponent,
    AddAnnonceComponent,
    EditAnnonceComponent,
    AnnonceAttenteComponent,
    AnnonceAttenteByIdComponent,
    AgencesDjerbaComponent,
    ProfileComponent,
    Recherche1Pipe,
    PromoteurListComponent,
    ListeAgenceMobComponent,
    ListemateriauxComponent,
    ListeagenceserviceComponent,
    ListnewannonceComponent,
    AddnewannonceComponent,
    UpdateannonceComponent
  ],

  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    InterceptorInterceptor,  // your existing interceptor (if it's a class, not a provider config – check)
    // ✅ Register your new AdminAuthInterceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AdminAuthInterceptor,
      multi: true
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
  ],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ListeagenceserviceComponent
  ],
})
export class AppModule { }